import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

//import createPersiste from 'vue-savedata'
//import createPersistedState from 'vuex-persistedstate'
// import VuexPersistence from 'vuex-persist'
// const vuexLocal = new VuexPersistence({
//     storage: window.localStorage
// })


const store = new Vuex.Store({
    state:localStorage.getItem('state')?JSON.parse(localStorage.getItem('state')):state,
    mutations,
    getters,
    actions,
    plugins: []
})

export default store
